export default "__VITE_ASSET__BZ2LRPW3__"